"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBellOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M28.45 20.38C26.29 19.29 25 16.72 25 13.52v-1.23C25 6.3 21.8 3 16 3s-9 3.39-9 9.29v1.23c0 3.15-1.32 5.78-3.45 6.86l-.55.28V25h8c.35 4.1 2.84 5 5 5 1.74 0 4.58-.68 5-5h8v-4.34zM16 28c-1.33 0-2.68-.39-2.95-3H19c-.32 2.61-1.67 3-3 3zm11-5H5v-1.14c2.52-1.57 4-4.63 4-8.34v-1.23C9 7.45 11.35 5 16 5s7 2.45 7 7.29v1.23c0 3.71 1.48 6.77 4 8.34z" })));
}
exports.default = SvgBellOutline;
//# sourceMappingURL=BellOutline.js.map